import { render, staticRenderFns } from "./dragger.vue?vue&type=template&id=5676733a&scoped=true&"
import script from "./dragger.vue?vue&type=script&lang=js&"
export * from "./dragger.vue?vue&type=script&lang=js&"
import style0 from "./dragger.vue?vue&type=style&index=0&id=5676733a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5676733a",
  null
  
)

export default component.exports